module.exports = __webpack_public_path__ + "682c6143b3f39f586c445daac5bcfa11.svg";